module.exports = __webpack_public_path__ + "static/media/web_riviera.bd8d6d5e.png";